// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1ZJ4C","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2ag-v","obliqueLine":"membershipbadge_obliqueLine__2bLyw"};